export const isRequired = value => !!value || 'Requerido.'
export const isNumeric = value => /^[0-9]*$/.test(value) || 'El valor debe ser numérico.'
export const isEmail = value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'El email debe ser válido.'
export const isRequiredNumeric = value => (!!value || value === 0) || 'Requerido.'
export const isRequiredBoolean = value => (!!value || value === false) || 'Requerido.'

export const minimum = (min) => {
  return value => (value ? value.length : 0) >= min || `Minimo ${min} caracteres.`
}
